import * as React from 'react'

export const NotFound = () => <div>Not Found</div>
